/* eslint-disable max-lines */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
/* eslint-disable sort-keys */
import React, { useState, useEffect } from 'react'
import { Eye, EyeOff } from 'react-feather'
import BaseCard from '../../components/BaseCard/BaseCard'
import TagBrandIneditos from '../../assets/imagens/tag-brand-ineditos.png'
import TagBrandCuradoria from '../../assets/imagens/tag-brand-curadoria.png'
import * as S from './style'
import { TypographyV2 as Typography, Form } from '@taglivros/tag-components'
import Button from '../../components/Button/Button'
import { patchDadosAssociado } from '../../api/associado.servico'
import { useAssociado } from '../../contexts/AssociadoContext'
import { useGlobal } from '../../contexts/GlobalContext'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, ROUTE_BASEPATH, MODAL_ERRO_ATUALIZACAO_ASSINATURA } from '../../constants'
import { useTheme } from 'styled-components'
import { navigate, useLocation } from '@reach/router'
import { defaultFormInputFields, formMask, formValidate, prefillFormFields } from './formSetup'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import { bool, func } from 'prop-types'
import ModalErro from '../../components/ModalErro/ModalErro'
import ModalSetup from '../../components/ModalSetup/ModalSetup'
import { formatMesPorExtenso } from '../../utils/formatter/formatter'
import { ReactComponent as TagExperienciasIcon } from '../../assets/imagens/tag-experiencias-literarias.svg'

const PasswordVisibilityToggle = ( { visible, onToggle } ) => {
  const Icon = visible ? EyeOff : Eye
  const label = visible ? 'Esconder senha' : 'Mostrar senha'

  const handleKeyDown = ( event ) => {
    if ( event.key === 'Enter' || event.key === ' ' ) {
      event.preventDefault()
      onToggle()
    }
  }

  return (
    <Icon
      aria-label={ label }
      className="is-clickable"
      onClick={ onToggle }
      onKeyDown={ handleKeyDown }
      role="button"
      tabIndex={ 0 }
    />
  )
}

PasswordVisibilityToggle.propTypes = {
  'onToggle': func.isRequired,
  'visible': bool.isRequired,
}

const buildPasswordVisibilityIcon = ( visible, onToggle ) => {
  const PasswordVisibilityIcon = () => (
    <PasswordVisibilityToggle
      onToggle={ onToggle }
      visible={ visible }
    />
  )
  return PasswordVisibilityIcon
}

// eslint-disable-next-line max-statements
const SetupAssinatura = ( { enableLoading } ) => {
  const [ isValidForm, setIsValidForm ] = useState( false )
  const [ patchAssinaturaError, setPatchAssinaturaError ] = useState( false )
  const [ isLoading, setIsLoading ] = useState( enableLoading )
  const [ showModalSuccess, setShowModalSuccess ] = useState( false )
  const [ isSubmitting, setIsSubmitting ] = useState( false )
  const [ showPassword, setShowPassword ] = useState( false )
  const [ showPasswordConfirmation, setShowPasswordConfirmation ] = useState( false )
  const { dadosAssociado, fetchDadosAssociado } = useAssociado()
  const [ formInputFields, setFormInputFields ] = useState( defaultFormInputFields )
  const [ subscriptionTheme, setSubscriptionTheme ] = useState( {} )
  const { dadosGlobaisAssociado, modalidadesDaAssinatura, setShouldShowSetupUserData, setShouldShowHeader, setShouldShowMenu, shouldShowSetupUserData, isSetupReativacao } = useGlobal()
  const { state } = useLocation()
  const theme = useTheme().v2

  const updateFormFields = ( inputId, value, isValid, helperText ) => {
    setFormInputFields( prevValue => ( {
      ...prevValue,
      [ inputId ]: {
        ...prevValue[ inputId ],
        value,
        isValid,
        helperText,
      }
    } ) )
  }

  const formatTagMonth = ( mesTag ) => {
    const parts = mesTag.split( '/' )
    const month = parseInt( parts[ 0 ], 10 )
    const year = parseInt( parts[ 1 ], 10 )

    const monthName = formatMesPorExtenso( month )
    return `${monthName} / ${year}`
  }

  const calculateSecondMonth = ( firstKitMonth, saleMonth ) => {
    const [ monthOffer, yearOffer ] = firstKitMonth.split( '/' ).map( Number )
    const [ monthSale, yearSale ] = saleMonth.split( '/' ).map( Number )

    const firstKitDate = ( yearOffer * 12 ) + monthOffer
    const saleDate = ( yearSale * 12 ) + monthSale

    if ( firstKitDate < saleDate ) {
      return saleMonth
    } else if ( firstKitDate === saleDate ) {
      let month = monthSale + 1
      let year = yearSale
      if ( month > 12 ) {
        month = 1
        year += 1
      }
      return `${month}/${year}`
    } else {
      let month = monthSale + 2
      let year = yearSale
      while ( month > 12 ) {
        month -= 12
        year += 1
      }
      return `${month}/${year}`
    }
  }

  const firstSubscription = dadosGlobaisAssociado?.assinaturas?.[ 0 ]
  const isPlanoAnual = firstSubscription?.plano === 'Anual'
  const firstKit = firstSubscription?.primeiroKitTitulo

  let secondKit = null
  if ( firstSubscription?.segundoMesTag ) {
    secondKit = formatTagMonth( firstSubscription.segundoMesTag )
  } else if ( firstSubscription?.vendaMesTag && firstSubscription?.primeiroKitMesTag ) {
    const secondMonth = calculateSecondMonth( firstSubscription.primeiroKitMesTag, firstSubscription.vendaMesTag )
    secondKit = formatTagMonth( secondMonth )
  }

  const checkFormValidity = () => {
    const keys = Object.keys( formInputFields )
      .map( ( key ) => formInputFields[ key ].isValid )
    const isValid = keys.every( ( value ) => value === true )
    setIsValidForm( isValid )
  }

  useEffect( () => {
    fetchDadosAssociado()
    setShouldShowHeader( false )
    setShouldShowMenu( false )
    return () => {
      setShouldShowHeader( true )
    }
  }, [] )

  useEffect( () => {
    checkFormValidity()
  }, [ formInputFields ] )

  useEffect( () => {
    prefillFormFields( dadosAssociado, updateFormFields )
  }, [ dadosAssociado ] )

  useEffect( () => {
    if ( ( shouldShowSetupUserData !== null && !shouldShowSetupUserData ) ) {
      setShouldShowMenu( true )
      navigate( ROUTE_BASEPATH, { 'replace': true } )
    }
  }, [ shouldShowSetupUserData ] )

  useEffect( () => {
    if ( !modalidadesDaAssinatura ) {
      return
    }
    const themeDict = {
      [ MODALIDADE_CURADORIA.visualizacao ]: {
        'image': TagBrandCuradoria,
        'themeColor': 'CUR-400',
      },
      [ MODALIDADE_INEDITOS.visualizacao ]: {
        'image': TagBrandIneditos,
        'themeColor': 'INE-300',
      },
    }[ state?.modalidadeSelecionada || modalidadesDaAssinatura[ 0 ] ]
    setSubscriptionTheme( themeDict )
    setIsLoading( false )
  }, [ modalidadesDaAssinatura ] )

  const passwordConfirmation = ( inputId, value, isValid, helperText ) => {
    if ( inputId !== 'passwordConfirmation' ) {
      return { isValid, helperText }
    }
    if ( value === formInputFields.password.value ) {
      return { 'isValid': true, 'helperText': '' }
    }
    return { 'isValid': false, 'helperText': 'A confirmação de senha é diferente da senha' }
  }

  const formOnChange = ( inputId, value, isValid, helperText ) => {
    const { 'isValid': validatedIsValid, 'helperText': validatedHelperText } = passwordConfirmation( inputId, value, isValid, helperText )
    updateFormFields( inputId, value, validatedIsValid, validatedHelperText )
  }

  const formOnSubmit = async() => {
    const birthDate = formInputFields.birthDate.value
    const dtNascimento = `${birthDate.substring( 0, 2 )}/${birthDate.substring( 3, 5 )}/${birthDate.substring( 6, 10 )}`
    const payload = {
      'nome': dadosAssociado.nome,
      'sobrenome': dadosAssociado.sobrenome,
      'email': dadosAssociado.email,
      'cpf': dadosAssociado.cpf,
      dtNascimento,
      'sexo': formInputFields.gender.value,
      'senha': formInputFields.password.value,
      'porque_assinou': formInputFields.whyDidSubscribed.value,
    }

    setIsSubmitting( true )
    try {
      const patchResponse = await patchDadosAssociado( payload )
      if ( isPlanoAnual ) {
        setShowModalSuccess( true )
      } else {
        handleCloseModalSuccess()
      }
    } catch ( error ) {
      setPatchAssinaturaError( true )
    } finally {
      setIsSubmitting( false )
    }
  }

  const handleCloseModalSuccess = () => {
    setShowModalSuccess( false )
    setShouldShowSetupUserData( false )
    setShouldShowMenu( true )
    navigate( ROUTE_BASEPATH, { 'replace': true } )
  }

  const titleAction = isSetupReativacao ? 'continuar' : 'iniciar'
  const subtitleAction = isSetupReativacao ? 'reativada' : 'ativada'

  if ( isLoading ) {
    return (
      <S.SetupWrapper>
        <S.LoadingContainer>
          <InlineLoader />
        </S.LoadingContainer>
      </S.SetupWrapper>
    )
  }

  return (
    <S.SetupWrapper>
      <S.IconContainer>
        <TagExperienciasIcon />
      </S.IconContainer>
      <BaseCard>
        <S.Container>
          <S.BrandContainer>
            <img
              src={ subscriptionTheme.image }
              width="100%"
              alt=""
            />
          </S.BrandContainer>

          <S.HeaderContainer>
            <Typography
              as="h2"
              color={ subscriptionTheme.themeColor }
              variant="subtitle-large-bold"
            >
              Tudo certo para {titleAction} a sua história com a TAG!
            </Typography>

            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-regular"
            >
              Sua assinatura já foi {subtitleAction} e enviamos um email com todos os detalhes para
            </Typography>
            {' '}
            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-bold"
            >
              {dadosAssociado.email}
            </Typography>

            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-regular"
            >
              Mas falta conhecer melhor o personagem principal dessa história, você!
            </Typography>
          </S.HeaderContainer>
          <S.FormContainer>
            <Form
              inputFields={ [
                [ formInputFields.gender ],
                [ formInputFields.birthDate ],
                [ formInputFields.whyDidSubscribed ],
                [
                  {
                    ...formInputFields.password,
                    'type': showPassword ? 'text' : 'password',
                    'Icon': buildPasswordVisibilityIcon( showPassword, () => setShowPassword( ( previousValue ) => !previousValue ) ),
                  }
                ],
                [
                  {
                    ...formInputFields.passwordConfirmation,
                    'type': showPasswordConfirmation ? 'text' : 'password',
                    'Icon': buildPasswordVisibilityIcon( showPasswordConfirmation, () => setShowPasswordConfirmation( ( previousValue ) => !previousValue ) ),
                  }
                ],
              ] }
              mask={ formMask }
              onChange={ formOnChange }
              onSubmit={ formOnSubmit }
              validate={ formValidate }
            />
          </S.FormContainer>

          <S.FooterContainer>
            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-regular"
            >
              Sua primeira caixinha está a caminho — fique de olho no seu email para acompanhar a entrega.
            </Typography>

            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-regular"
            >
              Você pode gerenciar sua assinatura a qualquer momento na área do associado.
            </Typography>
          </S.FooterContainer>

          <Button
            disabled={ !isValidForm || isSubmitting }
            onClick={ formOnSubmit }
            color={ theme.palette[ subscriptionTheme.themeColor ] }
          >
            { isSubmitting ? (
              <S.SubmitSpinner
                aria-label="Enviando"
                role="status"
              />
            ) : (
              <Typography
                color="WHITE"
                variant="button-medium-bold"
              >
                CONTINUAR PARA ÁREA DO ASSOCIADO
              </Typography>
            ) }
          </Button>
        </S.Container>
        <ModalErro
          bottomMessage={ MODAL_ERRO_ATUALIZACAO_ASSINATURA.MENSAGEM }
          descricao={ MODAL_ERRO_ATUALIZACAO_ASSINATURA.DESCRICAO }
          showModal={ patchAssinaturaError }
          titulo={ MODAL_ERRO_ATUALIZACAO_ASSINATURA.TITULO }
          toggleModal={ () => setPatchAssinaturaError( false ) }
        />
        { isPlanoAnual ? (
          <ModalSetup
            open={ showModalSuccess }
            onClick={ handleCloseModalSuccess }
            firstKit={ firstKit }
            secondKit={ secondKit }
          />
        ) : null }
      </BaseCard>
    </S.SetupWrapper>
  )
}

SetupAssinatura.propTypes = {
  'enableLoading': bool,
}

SetupAssinatura.defaultProps = {
  'enableLoading': true,
}

export default SetupAssinatura
